export default "/images/plus-circle.svg?6ccef3018bcc6d53d56e94a66618a0c0";